import { ProductsListUI } from './ProductsListUI'
import { useProductsList } from './useProductsList'

export const ProductsList = () => {
  const productsListProps = useProductsList({ basePath: '/produtos', collapsibleFilters: true })
  return <ProductsListUI {...productsListProps} />
}

export default ProductsList
